import React from 'react';
import { Container, TabContent, TabPane, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import classnames from 'classnames';

class Project extends React.Component {
    constructor(props) {
      super(props);
  
      this.toggle = this.toggle.bind(this);
      this.state = {
        activeTab: '1'
      };
    }
  
    toggle(tab) {
      if (this.state.activeTab !== tab) {
        this.setState({
          activeTab: tab
        });
      }
    }
  
    render() {
      return <div>
        <Container>
          <Nav tabs>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                       onClick={() => { this.toggle('1'); }}>
                Fanorona
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '2' })}
                       onClick={() => { this.toggle('2'); }}>
                Madagascar Election
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '3' })}
                       onClick={() => { this.toggle('3'); }}>
                Family Tree
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
            <Fanorona/>
            </TabPane>
            <TabPane tabId="2">
              <Madastat/>
            </TabPane>
            <TabPane tabId="3">
              <br></br>
              <p>
                  See : <a href="https://rajoelina.pythonanywhere.com">https://rajoelina.pythonanywhere.com</a>
              </p>
              <MyFamilytree/>
              <p style={{paddingBottom:"200px"}}></p>
            </TabPane>          
          </TabContent>
        </Container>
      </div>;
    }
  }

class Iframes extends React.Component {
render() {
    return(         
        <div>          
        <iframe title={this.props.title} height={this.props.height} width={this.props.width} src={this.props.src} />          
        </div>
    );
    }
}

class Fanorona extends React.Component {
    render() {
    return (
    <Container>
        <div style={{margin:"25px 0px"}}>
          webpage: <a href="https://fanoronaraf.pythonanywhere.com">https://fanoronaraf.pythonanywhere.com</a><br />
          github: <a href="https://github.com/AndryRajoelimanana/Fanorona_raf">https://github.com/AndryRajoelimanana/Fanorona_raf</a><br />
        </div>
        <Row style={{margin:"25px 0px"}}>
        <Col col-12="true">
            <Iframes src="https://fanoronaraf.pythonanywhere.com" title="frameP1" width="100%" height="670px"/>
        </Col>
        </Row>
        <Row>
          <Col>
          <h3>Rules</h3>
          
          A traditional board game of strategy from Madagascar. 
        
          <ul>
            <li>Opponent pieces can be captured either by approach or by withdrawal. 
          In each turn, you can make multiple moves if the active piece can capture, but it may not revisit a position that has already visited.</li>
            <li>A player must capture when a capturing move is available.</li>
            <li>When a player has already captured opponent's pieces, the subsequent move must be a capture.</li>
            <li>A player cannot make a succesive similar forward move type ( He must change direction with each move).</li>
            <li>A player win when all opponent's pieces has been captured.</li>
          </ul>
          </Col>
        </Row>
    </Container>
    )
    }
} 

class Madastat extends React.Component {
    render() {
        return (
        <Container>
        <div style={{margin:"25px 0px"}}>
          webpage: <a href="https://madastat.pythonanywhere.com">https://madastat.pythonanywhere.com</a><br />
          github: <a href="https://github.com/AndryRajoelimanana/MadagascarElection">https://github.com/AndryRajoelimanana/MadagascarElection</a><br />
        </div>
        <Row style={{margin:"25px 0px"}}>
            <Col col-12="true">
            <Iframes src="https://madastat.pythonanywhere.com" title="frameP2" width="100%" height="670px"/>
            </Col>
        </Row>
        </Container>
        )
    }
    }     

class MyFamilytree extends React.Component {
    render() {
        return (
        <Container>
        <Row style={{margin:"25px 0px"}}>
            <Col col-12="true">
            <Iframes src="https://rajoelina.pythonanywhere.com" title="frameP3" width="100%" height="670px"/>
            </Col>
        </Row>
        </Container>
        )
    }
}    


export default Project;